import React from 'react';
import cx from 'classnames';

import styles from './HeroOffsetImage.module.scss';

import FadeIn from 'src/components/FadeIn';

export type Props = {
  className?: string;
  copyChildren?: React.ReactNode;
  hasLargeTitle?: boolean;
  imageAlt: string;
  imageUrl: string;
  subtitle?: string;
  title: string;
};

const HeroOffsetImage: React.FC<Props> = ({
  className = '',
  copyChildren,
  title,
  subtitle,
  hasLargeTitle = false,
  imageAlt,
  imageUrl,
}) => {
  return (
    <div className={cx(styles.heroOffset, className)} data-cy="hero-offset">
      <div className={`${styles.heroOffset__copy} color-background-blue-gradient`}>
        <FadeIn duration={0.4} up>
          <div className="container">
            <div className={styles.heroOffset__copyContainer}>
              <h1
                className={cx(styles.heroOffset__title, hasLargeTitle ? 'font-size-title-x-large' : 'text-display_1')}
                data-cy="hero-offset-title"
              >
                {title}
              </h1>
              {subtitle && (
                <p
                  className={`${styles.heroOffset__subtitle} font-family-mono`}
                  dangerouslySetInnerHTML={{ __html: subtitle }}
                  data-cy="hero-offset-paragraph"
                />
              )}
              {copyChildren}
            </div>
          </div>
        </FadeIn>
      </div>
      <div className={`${styles.heroOffset__imageContainer} container`}>
        <FadeIn duration={0.3}>
          <img className={styles.heroOffset__image} src={imageUrl} alt={imageAlt} data-cy="hero-offset-image" />
        </FadeIn>
      </div>
    </div>
  );
};

export { HeroOffsetImage };
